import Parser from 'html-react-parser';

export default {
  type: 'postProcessor',
  name: 'htmlToReact',
  process(value, key, options) {
    return options.allowHtml ? Parser(value) : value;
  },
};
